export default __webpack_public_path__ + "static/media/juseno_2.98345a8b.png";